<div class="fpx-form-control">
  
  <fpx-label *ngIf="label" [control]="formControl" [label]="label" ></fpx-label>
  
  <div class="mat-radio-group-wrapper fpx-field-content" [ngClass]="ngTemplateName">
    <mat-radio-group disableRipple [formControl]="formControl" 
      [ngClass]="'radio-group-direction-' + direction"
      [labelPosition]="labelPosition">
      <ng-container *ngIf="selectableList$ | async as selectableDataList">
        <ng-container *ngFor="let selectedData of selectableDataList">
          <mat-radio-button [value]="selectedData.id" disableRipple>
            <ng-container [ngTemplateOutlet]="getTemplate(ngTemplateName) || defaultTemplate" [ngTemplateOutletContext]="{ $implicit: selectedData }"></ng-container>
          </mat-radio-button>
        </ng-container>
      </ng-container>
    </mat-radio-group>
  </div>
</div>

<ng-template #defaultTemplate let-selectableData>{{ selectableData?.text | translate }}</ng-template>
